/** Mirrors backend chat.errors.ts */
export const CHAT_ERROR_CODE = {
	NO_TOKENS: 'no_tokens',
	NO_LEGAL_IMAGE: 'no_legal_image',
	NO_LEGAL_CONTENT: 'no_legal_content',
	IMAGE_GENERATION_FAILED: 'image_generation_failed',
	VIDEO_GENERATION_FAILED: 'video_generation_failed',
};
